import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as EpimsBankActions from './bank.actions';
import { EpimsBankService } from '../../services/bank.service';

@Injectable()
export class EpimsBankEffects {
  loadEpimsBank$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EpimsBankActions.loadEpimsBank),
      exhaustMap((_) =>
        this.bankService.getEpimsBank().pipe(
          map((data) => EpimsBankActions.loadEpimsBankSuccess({ bank: data })),
          catchError((error) =>
            of(EpimsBankActions.loadEpimsBankFailure({ error }))
          )
        )
      )
    )
  );

  addEpimsBank$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EpimsBankActions.addEpimsBank),
      concatMap(({ newEpimsBank }) =>
        this.bankService.createEpimsBank(newEpimsBank).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return EpimsBankActions.addEpimsBankSuccess({ newEpimsBank: data });
          }),
          catchError((error) =>
            of(
              EpimsBankActions.addEpimsBankFailure({
                error: error.error.message,
              })
            )
          )
        )
      )
    )
  );

  updateEpimsBank$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EpimsBankActions.updateEpimsBank),
      map((action) => action.updateEpimsBank),
      concatMap((updateEpimsBank) =>
        this.bankService.updateEpimsBank(updateEpimsBank).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return EpimsBankActions.updateEpimsBankSuccess({
              updateEpimsBank: updateEpimsBank,
            });
          }),
          catchError((error) =>
            of(
              EpimsBankActions.updateEpimsBankFailure({ error: error.message })
            )
          )
        )
      )
    )
  );

  removeEpimsBank$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EpimsBankActions.removeEpimsBank),
      map((action) => action.ids),
      concatMap((ids) =>
        this.bankService.deleteEpimsBank(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return EpimsBankActions.removeEpimsBankSuccess({ ids });
          }),
          catchError((error) =>
            of(
              EpimsBankActions.updateEpimsBankFailure({ error: error.message })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private bankService: EpimsBankService,
    private notification: NotificationService
  ) {}
}
